// extracted by mini-css-extract-plugin
module.exports = {"inngang":"dh-sk-inngang","inngang__header":"dh-sk-inngang__header","inngang__merkelapp":"dh-sk-inngang__merkelapp"};